const FirebaseConfig = {
	apiKey: "AIzaSyDjt3db9uQk4HSElYnz_oAEbqIoJQ5WPLc",
	authDomain: "vp-cms-3d2a5.firebaseapp.com",
	projectId: "vp-cms-3d2a5",
	storageBucket: "vp-cms-3d2a5.firebasestorage.app",
	messagingSenderId: "311746546931",
	appId: "1:311746546931:web:c46994cf18f34a06cd7b86",
	measurementId: "G-Y4JWBSQWLF",
};

export default FirebaseConfig;
